import { createFileRoute, Navigate, useLocation } from '@tanstack/react-router';
import { OtpWrapper, RegisterUserForm } from '@amber-ui/core';

function OtpRegister() {
  const { searchStr } = useLocation();
  const searchParams = new URLSearchParams(searchStr);
  const otp = searchParams.get('otp');
  if (!otp) return <Navigate to="/otp/error" replace />;
  return (
    <OtpWrapper token={otp}>
      <RegisterUserForm token={otp} />
    </OtpWrapper>
  );
}

export const Route = createFileRoute('/otp/register')({
  component: OtpRegister,
});
